module.exports = __webpack_public_path__ + "img/proyecto_5.b01d3a3d.png";